import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import iziToast from "izitoast";
import { useAuth } from "../../AuthContext";

const Contact = () => {
  const navigate = useNavigate();
  const { apipath } = useAuth();
  const [contactData, setContactData] = useState(null);
  const [showThankYouPopup, setShowThankYouPopup] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phoneNo: '',
    email: '',
    address: '',
    companyName: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Phone number validation - only digits and max 10 characters
    if (name === 'phoneNo') {
      // Remove any non-digit characters
      const digitsOnly = value.replace(/\D/g, '');
      // Limit to 10 digits
      if (digitsOnly.length <= 10) {
        setFormData({ ...formData, [name]: digitsOnly });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apipath}/footer/details`); // Adjust the URL as needed
        console.log(response.data);
        setContactData(response.data);
      } catch (error) {
        console.error('Error fetching about data:', error);
      }
    };

    fetchData();
  }, []);

  if (!contactData) {
    return <div>Loading...</div>;
  }

  const handleRegister = async (e) => {
    e.preventDefault();
    
    // Validate phone number
    if (formData.phoneNo.length !== 10) {
      iziToast.error({
        message: 'Phone number must be exactly 10 digits.',
        position: 'topCenter',
      });
      return;
    }
    
    // Validate all required fields
    if (!formData.name || !formData.email || !formData.phoneNo || !formData.address || !formData.companyName || !formData.message) {
      iziToast.error({
        message: 'Please fill in all required fields.',
        position: 'topCenter',
      });
      return;
    }
    
    console.log('Sending form data:', formData); // Debug log
    
    try {
      const response = await axios.post(`${apipath}/contact/add`, formData);
      console.log('Response:', response); // Debug log
      
      // Check for success in response data
      if (response.data && response.data.success === true) {
        setFormData({
          name: '',
          phoneNo: '',
          email: '',
          address: '',
          companyName: '',
          message: ''
        });
        setShowThankYouPopup(true);
      } else if (response.data && response.data.success === false) {
        // Handle API returning success: false with error message
        iziToast.error({
          message: response.data.error || 'Contact submission failed',
          position: 'topCenter',
        });
      } else {
        iziToast.error({
          message: 'Contact submission failed',
          position: 'topCenter',
        });
      }
    } catch (error) {
      console.error('Error details:', error);
      console.error('Error response:', error.response?.data);
      
      // Handle specific API errors
      if (error.response?.data?.error) {
        const errorMessage = error.response.data.error;
        
        if (errorMessage.includes('Duplicate phoneNo')) {
          iziToast.error({
            message: 'This phone number is already registered. Please use a different phone number.',
            position: 'topCenter',
          });
        } else if (errorMessage.includes('Duplicate email')) {
          iziToast.error({
            message: 'This email is already registered. Please use a different email.',
            position: 'topCenter',
          });
        } else {
          iziToast.error({
            message: errorMessage,
            position: 'topCenter',
          });
        }
      } else if (error.response?.data?.message) {
        iziToast.error({
          message: error.response.data.message,
          position: 'topCenter',
        });
      } else {
        iziToast.error({
          message: 'Failed to submit contact form. Please try again.',
          position: 'topCenter',
        });
      }
      
      // Don't clear form or show success popup on error
      // Let user fix the issue and try again

      // if (error.response && error.response.data && error.response.data.message) {
      //   const errorMessage = error.response.data.message;

      //   if (errorMessage.includes('E11000 duplicate key error collection')) {
      //     if (errorMessage.includes('phoneNo')) {
      //       iziToast.error({
      //         message: 'This phone number is already registered.',
      //         position: 'topCenter',
      //       });
      //     } else if (errorMessage.includes('email')) {
      //       iziToast.error({
      //         message: 'This email is already registered.',
      //         position: 'topCenter',
      //       });
      //     } else {
      //       iziToast.error({
      //         message: 'A duplicate key error occurred.',
      //         position: 'topCenter',
      //       });
      //     }
      //   } else {
      //     iziToast.error({
      //       message: errorMessage,
      //       position: 'topCenter',
      //     });
      //   }
      // } else {
      //   iziToast.error({
      //     message: 'An error occurred',
      //     position: 'topCenter',
      //   });
      // }
    }
  };

  const closeThankYouPopup = () => {
    setShowThankYouPopup(false);
  };

  return (
    <>
      <Navbar />

      <Link to="/" className="float">
        <img src="imgs-alu/whtsp.png" alt="" />
      </Link>

      <div className="container-fluid main-banner">
        <div className="heading-main">
          <h1 className="text-[48px] text-white font-candal text-center">
            Contact Us
          </h1>
          <h4 className="text-[17px] font-exo text-white font-medium text-center">
            Home{" "}
            <i className="bi bi-chevron-double-right text-light-yellow"></i>
            Contact Us
          </h4>
        </div>
      </div>

      <div className="container py-4">
        <div className="main-heading">
          <h1>
            C<span>ontact U</span>s
          </h1>
        </div>
      </div>

      <div className="container my-4 shadow-custom rounded-2xl flex flex-wrap">
        <div className="w-full lg:w-5/12 contact-bg p-5 rounded-custom ml-[-10px]">
          <h1 className="font-poppins font-semibold text-white text-2xl ">
            Contact Information
          </h1>
          <p className="font-poppins font-normal text-white text-base">
            Say something if you have a doubt
          </p>

          <div className="pt-10 lg:pt-16 list-none lg:pb-0 pb-16">
            <li className="font-poppins font-medium text-lg text-white lg:mb-4 mb-2">
              <i className="bi bi-telephone mr-2"></i>{" "}
              <a
                href="tel:+91 804 794 6943"
                className="no-underline text-white"
              >
                {contactData.phonenumber}
              </a>
            </li>
            <li className="font-poppins font-medium text-lg text-white lg:mb-4 mb-2">
              <i className="bi bi-envelope mr-2"></i>{" "}
              <a
                href="mailto:sales@narayanaluminium.com"
                className="no-underline text-white"
              >
                {contactData.email}
              </a>
            </li>
            <li className="font-poppins font-medium text-lg text-white lg:mb-4 mb-2">
              <i className="bi bi-geo-alt-fill mr-2"></i>
              {contactData.address}
            </li>
            <li className="font-poppins font-medium text-lg text-white lg:mb-4 mb-2">
              <i className="bi bi-globe mr-2"></i>{" "}
              <a
                href="https://narayanaluminium.com"
                className="no-underline text-white"
              >
                {contactData.weblink}
              </a>
            </li>
          </div>
        </div>
        <div className="w-full lg:w-7/12 p-5">
          <h1 className="font-poppins font-semibold text-black text-2xl">
            Get In Touch With Us
          </h1>
          <p className="font-poppins font-normal text-black text-base">
            We are happy to answer any questions you may have regarding our
            services.
          </p>

          <form className="flex flex-wrap mt-7" onSubmit={handleRegister}>
            <div className="w-full lg:w-1/2 px-3 py-2">
              <label
                htmlFor="name"
                className="block font-poppins font-base text-semibold text-label-gray mb-1"
              >
                Name
              </label>
              <input
                type="text"
                placeholder="Name"
                className="w-full p-2 border-b-2 border-input-gray font-poppins font-normal text-base text-input-gray"
                name="name"
                value={formData.name}
                onChange={handleChange}
                minLength="3"
                required
              />
            </div>
            <div className="w-full lg:w-1/2 px-3 py-2">
              <label
                htmlFor="name"
                className="block font-poppins font-base text-semibold text-label-gray mb-1"
              >
                Email
              </label>
              <input
                type="email"
                placeholder="Email"
                className="w-full p-2 border-b-2 border-input-gray font-poppins font-normal text-base text-input-gray"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="w-full lg:w-1/2 px-3 py-2">
              <label
                htmlFor="name"
                className="block font-poppins font-base text-semibold text-label-gray mb-1"
              >
                Phone no.
              </label>
              <input
                type="tel"
                placeholder="Enter 10 digit phone number"
                className="w-full p-2 border-b-2 border-input-gray font-poppins font-normal text-base text-input-gray"
                name="phoneNo"
                value={formData.phoneNo}
                onChange={handleChange}
                maxLength="10"
                pattern="[0-9]{10}"
                title="Please enter exactly 10 digits"
                required
              />
            </div>
            <div className="w-full lg:w-1/2 px-3 py-2">
              <label
                htmlFor="name"
                className="block font-poppins font-base text-semibold text-label-gray mb-1"
              >
                Address
              </label>
              <input
                type="text"
                placeholder="Address"
                className="w-full p-2 border-b-2 border-input-gray font-poppins font-normal text-base text-input-gray"
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
              />
            </div>
            <div className="w-full lg:w-1/2 px-3 py-2">
              <label
                htmlFor="name"
                className="block font-poppins font-base text-semibold text-label-gray mb-1"
              >
                Company Name
              </label>
              <input
                type="text"
                placeholder="Company"
                className="w-full p-2 border-b-2 border-input-gray font-poppins font-normal text-base text-input-gray"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="w-full px-3 py-2">
              <label
                htmlFor="name"
                className="block font-poppins font-base text-semibold text-label-gray mb-1"
              >
                Message
              </label>
              <input
                type="text"
                placeholder="Message"
                className="w-full p-2 border-b-2 border-input-gray font-poppins font-normal text-base text-input-gray"
                name="message"
                value={formData.message}
                onChange={handleChange}
                maxLength={100}
                required
              />
            </div>
            <div className="w-full flex justify-end mt-4">
              <button 
                type="submit"
                className="py-2 px-12 rounded bg-m-blue font-poppins font-medium text-white text-lg border-1 border-m-blue hover:bg-transparent hover:!text-m-blue hover:ease-in-out duration-300"
              >
                Send Message
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Thank You Popup Modal */}
      {showThankYouPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 transform transition-all duration-300 scale-100 relative">
            {/* Close Icon */}
            <button
              onClick={closeThankYouPopup}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 p-1 rounded-full hover:bg-gray-100"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
            
            <div className="p-8 text-center">
              {/* Success Icon */}
              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6">
                <svg
                  className="h-8 w-8 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
              </div>
              
              {/* Thank You Message */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4 font-poppins">
                Thank You! 🎉
              </h3>
              <p className="text-gray-600 mb-6 font-poppins text-base leading-relaxed">
                Thank you for contacting us! We appreciate your message and our team will get back to you soon with all the information you need.
              </p>
              
              {/* Contact Info */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6">
                <p className="text-sm text-gray-700 font-medium mb-2">
                  📞 Call us directly: <span className="text-blue-600">+91-804 794 6943</span>
                </p>
                <p className="text-sm text-gray-700 font-medium">
                  ✉️ Email: <span className="text-blue-600">sales@narayanaluminium.com</span>
                </p>
              </div>
              
              {/* Close Button */}
              <button
                onClick={closeThankYouPopup}
                className="w-full bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-medium py-3 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                Got it! ✨
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Contact;
